import React from "react";

const RadioButtonWithoutLabel = ({
  id,
  name,
  label = "",
  value = "",
  selectedOption = "",
  onChange,
}) => {
  return (
    <input
      type="radio"
      id={`${id}`}
      name={`${name}`}
      value={`${value}`}
      checked={value == selectedOption}
      onChange={onChange}
      className="cursor-pointer accent-[#AB3C1B]"
    />
  );
};

export default RadioButtonWithoutLabel;
